// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"fc8fc1db","246":"a1716245","488":"c2b8bcfc"}[chunkId] + ".chunk.js";
};